/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsBackgroundSideBySideOptions
 */
export interface FxIdDomainSettingsBackgroundSideBySideOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsBackgroundSideBySideOptions
     */
    LeftImage: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsBackgroundSideBySideOptions
     */
    RightImage: string;
}

/**
 * Check if a given object implements the FxIdDomainSettingsBackgroundSideBySideOptions interface.
 */
export function instanceOfFxIdDomainSettingsBackgroundSideBySideOptions(value: object): value is FxIdDomainSettingsBackgroundSideBySideOptions {
    if (!('LeftImage' in value) || value['LeftImage'] === undefined) return false;
    if (!('RightImage' in value) || value['RightImage'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsBackgroundSideBySideOptionsFromJSON(json: any): FxIdDomainSettingsBackgroundSideBySideOptions {
    return FxIdDomainSettingsBackgroundSideBySideOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsBackgroundSideBySideOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsBackgroundSideBySideOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'LeftImage': json['LeftImage'],
        'RightImage': json['RightImage'],
    };
}

export function FxIdDomainSettingsBackgroundSideBySideOptionsToJSON(json: any): FxIdDomainSettingsBackgroundSideBySideOptions {
    return FxIdDomainSettingsBackgroundSideBySideOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsBackgroundSideBySideOptionsToJSONTyped(value?: FxIdDomainSettingsBackgroundSideBySideOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'LeftImage': value['LeftImage'],
        'RightImage': value['RightImage'],
    };
}

